import { create } from 'zustand'

const COLLAPSED_STORAGE_KEY = 'admin-sidebar-collapsed'

const getInitialCollapsed = (): boolean => {
  try {
    return localStorage.getItem(COLLAPSED_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

type AdminSidebarStore = {
  isOpen: boolean
  collapsed: boolean
  setIsOpen: (isOpen: boolean) => void
  toggle: () => void
  close: () => void
  toggleCollapsed: () => void
}

export const useAdminSidebarStore = create<AdminSidebarStore>(set => ({
  isOpen: false,
  collapsed: getInitialCollapsed(),
  setIsOpen: (isOpen: boolean) => set({ isOpen }),
  toggle: () => set(state => ({ isOpen: !state.isOpen })),
  close: () => set({ isOpen: false }),
  toggleCollapsed: () =>
    set(state => {
      const next = !state.collapsed
      try {
        localStorage.setItem(COLLAPSED_STORAGE_KEY, String(next))
      } catch (_) {
        void 0
      }
      return { collapsed: next }
    })
}))
